<template>
  <el-dialog title="导入商品" :visible.sync="visible" width="400px">
    <div>
      <p class="hige-tips">{{ $t('stores::products-info::importTips') }}</p>
      <p class="tips">
        1、{{ $t('stores::products-info::pleaseFirst') }}
        <el-button type="text" @click="exportGoods" :disabled="exportLoading">
          {{ $t('stores::products-info::exportGoods') }}
        </el-button>
        {{ $t('stores::products-info::editing') }}
        <i class="el-icon-loading" v-show="exportLoading"></i>
      </p>
      <p class="tips mb-40">2、{{ $t('stores::products-info::importFile') }}</p>
      <el-upload ref="upload" action="" drag :auto-upload="false" :show-file-list="false" :on-change="onchangeUpload">
        <div class="upload_wrap" v-if="fileUrl">
          <div class="list-wrap">
            <p>{{ fileUrl.name }}</p>
          </div>
        </div>
        <div class="upload_wrap">
          <i class="el-icon-plus"></i>
          <el-button class="add-file-btn">{{ $t('system::tip::upload_click') }}</el-button>
          <span>{{ $t('system::tip::upload_drag_tip') }}</span>
        </div>
        <div slot="tip">{{ $t('stores::products-info::importDesc') }}</div>
      </el-upload>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="submit" :loading="loading">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { importProducts } from '@/server/product'
const FILE_SIZE_RATE = 1024
export default {
  data() {
    return {
      visible: false,
      fileUrl: '',
      loading: false,
      fdata: null,
      exportLoading: false,
    }
  },
  props: {
    value: {},
  },
  methods: {
    async customUpload(file) {
      this.fdata = new FormData()
      this.fdata.append('upload_file', file.raw)
      this.loading = true
      const res = await importProducts(this.fdata, { type: 'product' })
      if (res.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
        this.visible = false
        this.$emit('save')
      }
      this.loading = false
    },
    onchangeUpload(file) {
      this.fileUrl = file
    },
    async submit() {
      if (!this.fileUrl) {
        this.$message.warning(this.$t('stores::products-info::importFirst'))
        return
      }
      const typeList = ['csv', 'xlsx', 'xls']
      const valid = typeList.some(i => this.fileUrl.name.toLowerCase().endsWith(i))
      if (!valid) {
        this.$message.warning(this.$t('system::tip::accept_file', { accept: 'csv,xls,xlsx' }))
        return false
      }
      const MAX_SIZE = 10
      if (MAX_SIZE * FILE_SIZE_RATE * FILE_SIZE_RATE < this.fileUrl.size) {
        this.$message.warning(this.$t('system::tip::fileSize_limit', { fileSize: 10 }))
        return false
      }
      // console.log(this.$refs.upload.submit)
      // this.$refs.upload.submit()
      this.customUpload(this.fileUrl)
    },
    async exportGoods() {
      this.$emit('export')
    },
  },
  watch: {
    value(val) {
      this.visible = val
      if (val) {
        this.fileUrl = ''
        this.fdata = null
      }
    },
    visible(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style scoped lang="scss">
.hige-tips {
  color: #ff8e40;
  line-height: 24px;
  margin-bottom: 12px;
}
.tips {
  color: #010517;
  line-height: 24px;
}
/deep/.el-dialog__header {
  border-bottom: none;
}
/deep/.el-dialog__headerbtn {
  z-index: 10;
}
/deep/.el-upload__tip {
  color: #999999;
  line-height: 1;
  // margin-top: -7px;
}
.upload_wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  line-height: 1;
  background: #f5f6f8;
  .el-icon-plus {
    font-size: 24px;
    color: #666666;
  }
  .add-file-btn {
    margin: 8px 0;
  }
  span {
    color: #999999;
  }
  .list-wrap {
    width: 200px;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    i {
      font-size: 20px;
    }
  }
}
</style>
